export const AgentLineWebsearch = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12.0004" cy="11.9984" r="9.6" stroke="currentColor" strokeWidth="1.5" />
    <path d="M2.40039 12H21.6004" stroke="currentColor" strokeWidth="1.5" />
    <ellipse cx="12.0004" cy="11.9984" rx="3.6" ry="9.6" stroke="currentColor" strokeWidth="1.5" />
  </svg>
);
